import { Link } from 'react-router-dom';

export default function HeroBanner() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '久久视频',
    url: 'https://jiujiu.video',
    description: '久久视频是您的高清视频在线观看首选平台，汇聚海量影视、综艺、短视频内容，流畅播放体验，随时随地畅享精彩视频世界。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20shot%20of%20a%20modern%20minimalist%20home%20theater%20setup%20with%20a%20large%20screen%20displaying%20abstract%20colorful%20visuals%2C%20warm%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20modern%20interior%20design%2C%20clean%20composition%2C%20professional%20photography%20with%20soft%20shadows%2C%20cinematic%20color%20grading%20with%20coral%20and%20teal%20accents&width=1800&height=800&seq=hero-bg-jiujiu&orientation=landscape"
            alt="久久视频 - 高清视频在线观看平台"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        </div>

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            高清视频在线观看
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
            汇聚海量影视、综艺、短视频内容，流畅播放体验，随时随地畅享精彩视频世界
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/dianying"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all whitespace-nowrap text-sm"
            >
              立即免费体验
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full transition-all whitespace-nowrap text-sm backdrop-blur-sm"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}